<div class="dialog-top">
  <h2 mat-dialog-title>{{ 'Generate offer for customer' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="form">
    <div class="cdc-form-field actif">
      <div class="cdc-label">{{ 'Select customer code' | translate }}</div>

      <input matInput
             type="text"
             formControlName="customerCode"
             placeholder="Enter customer code"
             maxlength="8">
      <mat-error *ngIf="form.get('customerCode')?.invalid && form.get('customerCode')?.touched">
        {{ 'Customer code must be empty or exactly 8 digits' | translate }}
      </mat-error>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button [disabled]="!form.valid" (click)="onConfirm()">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
